export const ratesColumns = [
    {
        name: "TIME FROM",
        selector: (row) => row["timeFrom"],
        sortable: true,
        center: true,
    },
    {
        name: "TIME TO",
        selector: (row) => row["timeTo"],
        sortable: true,
        center: true,
    },
    // {
    //     name: "ISACTIVE",
    //     selector: (row) => row["isActive"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "INITIAL DISTANCE",
    //     selector: (row) => row["initialDist"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "INITIAL DISTANCE CHARGE",
    //     selector: (row) => row["initialDistCharge"],
    //     sortable: true,
    //     center: true,
    // },
    {
        name: "PER KM CHARGE",
        selector: (row) => row["perKmCharge"],
        sortable: true,
        center: true,
    },
    // {
    //     name: "WAITING CHARGE PER MIN",
    //     selector: (row) => row["waitingChargePerMin"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "WAITING CHARGE AFTER TIME IN MIN",
    //     selector: (row) => row["waitingChargeAfterTimeInMin"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "TRIP TIME CHARGE PER MIN",
    //     selector: (row) => row["tripTimeChargePerMin"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "WAITING CALC THRESHOLD SPEED",
    //     selector: (row) => row["waitingCalcThresholdSpeed"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "SERVICE CITY",
    //     selector: (row) => row["serviceCityName"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "CAR TYPE",
    //     selector: (row) => row["carTypeName"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "BASE FARE TAX",
    //     selector: (row) => row["baseFareTaxPercentage"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "SERVICE TAX",
    //     selector: (row) => row["serviceFareTaxPercentage"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "DISCOUNT LOCATION",
    //     selector: (row) => row["discountLocationId"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "CORPORATE CLIENT",
    //     selector: (row) => row["corporateClientName"],
    //     sortable: true,
    //     center: true,
    // },
    // {
    //     name: "IS NIGHT FARE TIME SLOT",
    //     selector: (row) => row["isNightfareTimeSlot"],
    //     sortable: true,
    //     center: true,
    // },
    {
        name: "APPLICABLE FROM DATE",
        selector: (row) => row["applicableFromDate"],
        sortable: true,
        center: true,
    },
    {
        name: "APPLICABLE TO DATE",
        selector: (row) => row["applicableToDate"],
        sortable: true,
        center: true,
    },
    {
        name: "",
        cell: (row) => row["action"],
        sortable: true,
        center: true,
        width: "30px",
      },
];
export const rateFilterColumns = [
  {
    name: "Car Type",
    value: "carTypeId",
    type: "select",
  },
  {
    name: "Ride Type",
    value: "rideType",
    type: "select",
  },
  {
    name: "Booking Source",
    value: "bookingSource",
    type: "select",
  },
  // {
  //   name: "Terminal",
  //   value: "terminal",
  //   type: "select",
  // },
];